import React, { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Grid, Stack, Tooltip, Alert, Box } from '@mui/material';
import { SCUIDateRanger, SCUILoadingLinear, SCUINoRecordComponent } from '../../atomic/atoms';
import { SCUIContent } from '../../atomic/organisms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUICustomDataGrid } from '../../atomic/molecules';
import { SCUITextFieldWithSelectBox, SCUIBreadCrumb } from '../../atomic/molecules';
import cachePaymentImage from '../../assets/icons/svg/pageIcons/billingInfo.svg';
import { EmailAndSmsServiceLogsQuery } from '../../services/query';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { initialState } from './EmailAndSmsServiceLogs.helper';
import { EASL } from './emailAndSmsServiceLogs.classes';
import helper from '../../utils/helper';
import TimeHelper from '../../utils/time';

export const EmailAndSmsServiceLogs: FC<any> = () => {
    const { t } = useTranslation();

    const columns: ExtendedGridColDef[] = [
        { field: 'Id', headerName: 'Id', flex: 1, hide: true },
        { field: 'phoneNumber', headerName: t('general.phoneNumber'), flex: 1 },
        {
            field: 'message',
            headerName: t('general.message'),
            flex: 1,
            headerAlign: 'center',
            align: 'left',
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip placement="bottom" title={<h2>{params.row.message}</h2>}>
                            <p>{params.row.message}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'entegratorResult',
            headerName: t('general.entegratorResult'),
            flex: 1,
            headerAlign: 'center',
            align: 'left',
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip placement="bottom-start" title={<h2>{params.row.entegratorResult}</h2>}>
                            <p>{params.row.entegratorResult}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        { field: 'entegrator', headerName: t('general.entegrator'), flex: 1 },
        { field: 'sentDate', headerName: t('general.sentDate'), flex: 1 },
        { field: 'messageType', headerName: t('general.messageType'), flex: 1 },
        {
            field: 'status',
            headerName: t('general.status'),
            flex: 1,
            width: 10,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return params.row.status ? (
                    <CheckCircleIcon color="success" className="svg_icons" />
                ) : (
                    <CancelIcon color="error" className="svg_icons" />
                );
            },
        },
    ];
    const mailColumns: ExtendedGridColDef[] = [
        { field: 'Id', headerName: 'Id', flex: 1, hide: true },
        { field: 'from', headerName: t('general.from'), flex: 1 },
        { field: 'fromName', headerName: t('general.fromName'), flex: 1 },
        {
            field: 'subject',
            headerName: 'general.Subject',
            flex: 1,
            headerAlign: 'center',
            align: 'left',
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={<h2>{params.row.subject}</h2>}>
                            <p>{params.row.subject}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        { field: 'sentDate', headerName: t('general.sentDate'), flex: 1 },
        { field: 'errorDetail', headerName: 'Error', flex: 1 },
        {
            field: 'isSucceed',
            headerName: t('general.status'),
            flex: 1,
            width: 10,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return params.row.status ? (
                    <CheckCircleIcon color="success" className="svg_icons" />
                ) : (
                    <CancelIcon color="error" className="svg_icons" />
                );
            },
        },
    ];
    const [pageSize, setPageSize] = React.useState(10);
    const [pageNumber, setPageNumber] = React.useState(0);
    const [rowCount, setRowCount] = React.useState(0);
    const [take, setTake] = React.useState(10);
    const [skip, setSkip] = React.useState(1);
    const [searchedText, setSearchedText] = useState('');
    const [documentType, setDocumentType] = React.useState('Sms');
    const [smsFilterData, setSmsFilterData] = useState(initialState.smsFilters);
    const [mailFilterData, setMailFilterData] = useState(initialState.mailFilters);
    const [startDate, setStartDate] = React.useState('');
    const [endDate, setEndDate] = React.useState('');
    const [smsDatas, setSmsDatas] = React.useState<any>();
    const [mailDatas, setMailDatas] = React.useState<any>();
    const [smsDisplay, setSmsDisplay] = useState(false);
    const [filterDisplay, setFilterDisplay] = useState(true);
    const [mailDisplay, setMailDisplay] = useState(false);
    const [barDisplay, setBarDisplay] = useState(false);

    useEffect(() => {
        if (documentType === 'Sms')
            setSmsFilterData({
                ...smsFilterData,
                take: pageSize,
                skip: pageNumber + 1,
            });
        else
            setMailFilterData({
                ...mailFilterData,
                take: pageSize,
                skip: pageNumber + 1,
            });
        setTake(pageSize);
        setSkip(pageNumber + 1);
    }, [pageSize, pageNumber]);

    useEffect(() => {
        GetDataByDocumentType(documentType);
    }, [skip, take]);

    const _handlChangeDate = (event: any) => {
        setStartDate(event[0]);
        setEndDate(event[1]);
    };

    useEffect(() => {
        if (documentType === 'Sms') {
            setSmsFilterData({
                ...smsFilterData,
                phoneNumber: searchedText,
                endDate: endDate,
                beginDate: startDate,
            });
        } else {
            setMailFilterData({
                ...mailFilterData,
                customerMail: searchedText,
                endDate: endDate,
                beginDate: startDate,
            });
        }
    }, [searchedText, startDate, endDate, documentType]);

    const GetSmsLogByPhone = async (): Promise<any> => {
        try {
            EmailAndSmsServiceLogsQuery.GetSmsLogByPhone(smsFilterData).then((res: any) => {
                if (res.model.data) {
                    let parseDataSmsResult = res.model.data.map((item: any, index: any) => {
                        return {
                            id: index,
                            entegrator: item.entegrator || '-',
                            entegratorResult: item.entegratorResult || '-',
                            message: item.message || '-',
                            phoneNumber: (item.phoneNumber && '0' + item.phoneNumber) || '-',
                            sentDate: TimeHelper.formatDateHour(item.sentDate) || '-',
                            status: item.status,
                            messageType: item.messageType || '-',
                        };
                    });
                    setSmsDatas(parseDataSmsResult);
                    setRowCount(res.model.count);
                    setSmsDisplay(true);
                    setBarDisplay(false);
                    setMailDisplay(false);
                    setFilterDisplay(false);
                } else {
                    Swal.fire('Sms log bulunamadı', ' ', 'error');
                    setBarDisplay(false);
                }
            });
        } catch (error) {
            setSmsDisplay(false);
            setBarDisplay(false);
            console.log('Hata :>> ', error);
        }
    };

    const GetMailLogByReceiver = async (): Promise<any> => {
        try {
            EmailAndSmsServiceLogsQuery.GetMailLogByReceiver(mailFilterData).then((res: any) => {
                if (res.model.data) {
                    let parseDataMailResult = res.model.data.map((item: any, index: any) => {
                        return {
                            id: index,
                            from: item.from || '-',
                            to: item.to || '-',
                            fromName: item.fromName || '-',
                            subject: item.subject || '-',
                            sentDate: TimeHelper.formatDateHour(item.sentDate) || '-',
                            isSucceed: item.isSucceed || '-',
                            errorDetail: item.errorDetail || '-',
                        };
                    });
                    setRowCount(res.model.count);
                    setMailDatas(parseDataMailResult);
                    setMailDisplay(true);
                    setSmsDisplay(false);
                    setBarDisplay(false);
                    setFilterDisplay(false);
                } else {
                    Swal.fire('bulunamadı', ' ', 'error');
                    setBarDisplay(false);
                }
            });
        } catch (error) {
            setSmsDisplay(false);
            setBarDisplay(false);
            console.log('Hata :>> ', error);
        }
    };

    const GetDataByDocumentType = async (documentType: any) => {
        if (searchedText.length === 0) {
            setFilterDisplay(true);
            setSmsDisplay(false);
            setMailDisplay(false);
            return;
        }
        if (documentType.length === 0 || startDate.length === 0 || endDate.length === 0) {
            Swal.fire(t('general.emptyFieldControlText'), ' ', 'error');
            return;
        }
        if (documentType === 'Email') {
            GetMailLogByReceiver();
        } else {
            GetSmsLogByPhone();
        }
    };

    return (
        <SCUIContent>
            <Grid container direction="row" className={EASL.page}>
                <Box className={EASL.headerWrap} sx={{ width: '100%' }}>
                    <SCUIBreadCrumb
                        title={t('EmailAndSmsServiceLogs.emailAndSmsServiceHeader')}
                        componentLink={'EmailAndSmsServiceLogs'}
                    />
                </Box>
                <Grid
                    className={EASL.alertWrap}
                    sx={{ mb: 2 }}
                    size={{
                        xs: 12,
                    }}
                >
                    <Alert severity="info" sx={{ backgroundColor: '#e3f2fd' }}>
                        {t('EmailAndSmsServiceLogs.phoneNumberFormatInfo')}
                    </Alert>
                </Grid>
                <Stack
                    className={EASL.filtersRow}
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 1, sm: 2, md: 4, xl: 20 }}
                    sx={{ width: '100%' }}
                >
                    <Grid
                        className={EASL.dateRangeWrap}
                        sx={{ paddingRight: 1 }}
                        size={{
                            xs: 12,
                            md: 4,
                            lg: 3,
                            xl: 3,
                        }}
                    >
                        <SCUIDateRanger size="small" setDateRange={_handlChangeDate} dateFormat="YYYY-MM-DD" />
                    </Grid>
                    <Box className={EASL.searchCompositeWrap} sx={{ flex: 1, minWidth: 0 }}>
                        <SCUITextFieldWithSelectBox
                            marginTop="0.5rem"
                            placeholder={' '}
                            type={documentType == 'Sms' ? 'number' : ''}
                            buttonText={t('general.search')}
                            selectList={[
                                { value: 'Sms', text: t('EmailAndSmsServiceLogs.sms') },
                                { value: 'Email', text: t('EmailAndSmsServiceLogs.email') },
                            ]}
                            onChangeSelect={(event: any) => {
                                setDocumentType(event.target.value);
                                setSmsDisplay(false);
                                setMailDisplay(false);
                                setTake(10);
                                setPageNumber(1);
                            }}
                            selectValue={documentType}
                            onChangeTextField={(event: any) => {
                                setSearchedText(event.target.value);
                            }}
                            onClickButton={() => {
                                if (startDate.length === 0 || endDate.length === 0) {
                                    Swal.fire('Tarih uygun formatlı değil', ' ', 'error');
                                    return;
                                }
                                if (documentType === 'Email' && !helper.validateEmail(searchedText)) {
                                    Swal.fire('Email uygun formatlı değil', ' ', 'error');
                                    return;
                                }
                                setPageNumber(0);
                                GetDataByDocumentType(documentType);
                            }}
                            onKeyDownTextField={(e: any) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    if (documentType === 'Email' && !helper.validateEmail(searchedText)) {
                                        Swal.fire('Email uygun formatlı değil', ' ', 'error');
                                        return;
                                    }

                                    GetDataByDocumentType(documentType);
                                    setPageNumber(0);
                                }
                            }}
                        />
                    </Box>
                </Stack>
                <SCUILoadingLinear display={barDisplay} />
                {smsDisplay && (
                    <Grid className={EASL.smsToolbarSlot} container alignItems="center" justifyContent="center"></Grid>
                )}
                {filterDisplay && (
                    <Grid
                        className={EASL.emptyStateWrap}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUINoRecordComponent img={cachePaymentImage} />
                    </Grid>
                )}
                {smsDisplay && (
                    <Box className={EASL.smsGridWrap} sx={{ width: '100%' }}>
                        <SCUICustomDataGrid
                            randomId
                            rows={smsDatas}
                            columns={columns}
                            onPageSizeChange={(i: number) => {
                                setPageSize(i);
                            }}
                            pageSize={pageSize}
                            paginationModeChange
                            onPageChange={(i: number) => {
                                setPageNumber(i);
                            }}
                            page={pageNumber}
                            rowCount={rowCount}
                        />
                    </Box>
                )}

                {mailDisplay && (
                    <Box className={EASL.mailGridWrap} sx={{ width: '100%' }}>
                        <SCUICustomDataGrid
                            rows={mailDatas}
                            columns={mailColumns}
                            onPageSizeChange={(i: number) => {
                                setPageSize(i);
                            }}
                            pageSize={pageSize}
                            paginationModeChange
                            onPageChange={(i: number) => {
                                setPageNumber(i);
                            }}
                            page={pageNumber}
                            rowCount={rowCount}
                        />
                    </Box>
                )}
            </Grid>
        </SCUIContent>
    );
};
